// tslint:disable:max-line-length

import React from 'react';

export const ActionDuplicate = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="11.9,0 11.9,2.8 14.7,2.8 	" />
      <path d="M10.9,0H4.8v2.8H1.3V4v0.3v10.2V16h1.5h7.6h1.5v-1.5v-2.3h2.8V3.8h-3.8V0z M10.4,14.5H2.8V4.3h2v7.9h5.6V14.5z" />
    </svg>
  );
};
